/* eslint-disable max-len */
export default {
    ADD_TO_CART: 'Lägg till i varukorgen',
    ADD_TO_WISHLIST: 'Lägg till i önskelistan',
    APPLY: 'Använd',
    CALL_US: 'Kontakta oss',
    CANCEL: 'Avbryt',
    CHOOSE_OPTION: 'Välj ett alternativ',
    COMPLETED: 'Slutförd',
    COMPONENTS: 'Komponenter',
    COPY: 'Kopiera länk till design',
    COPIED: 'url kopieras till urklipp',
    CUSTOMER_SERVICE: 'Besoin d\'aide ? Notre Service Clients est à votre écoute',
    DETAILS: 'Detaljer',
    DIFFERENT_SIZE: 'Olika storlek på fötterna?',
    DONE_FOR_NOW: 'Designat klart för nu?',
    EMAIL: 'Email',
    EMAIL_DESIGN: 'Maila design',
    EMAIL_INVALID: 'Vänligen fyll i en giltig e-postadress.',
    EMAIL_SENT: 'Tack! En länk till dina skräddarsydda MyJoys har skickats till din vän.',
    EMAIL_SUMMARY: 'MyJoys: E-postsammanfattning',
    ENTER_EMBROIDERY: 'Fyll i specialbrodyr',
    HELP: 'Hjälp',
    HOURS: 'Mån-Tors 09:00-16:00, Fre 09:00-15:00',
    INVALID_ERROR: 'Fältet innehåller ogiltigt innehåll',
    MAKE_A_SELECTION: 'Gör ett val för att fortsätta',
    MAX_LENGTH_6: 'Max 6 tecken för block',
    MAX_LENGTH_3: 'Max 3 tecken för script',
    MENS: 'Herr',
    MESSAGE: 'Ecrivez',
    MESSAGE_US: 'Skicka meddelande',
    NEED_HELP: 'Behöver du hjälp? Vår kundservice är redo för dig.',
    NONE_SELECTED: 'Ingen vald',
    OK: 'Ok',
    PERSONALIZATION_POLICY: 'Personifiering Policy',
    PHONE_NUMBER: '0200727080',
    PHONE_NUMBER_FORMATTED: '0200 727080',
    PRINT: 'Skriv ut design',
    RECIPIENT_NAME: 'Mottagarens namn',
    RECIPIENT_EMAIL: 'Mottagarens Email',
    REQUIRED: 'Detta fält är obligatoriskt',
    RESET: 'Återställ',
    RESET_CONFIRM: 'Vill du återställa alla val?',
    RESET_CONFIRM_COPY: 'Om du fortsätter kommer alla val att återställas och din design kommer att gå förlorad.',
    SAVE: 'Spara',
    SAVE_EXIT: 'Spara & avsluta',

    SELECT_SIZE: 'Välj storlek',
    SELECT_WIDTH: 'Välj vidd',
    LEFT_SHOE_SIZE: 'Storlek för vänster fot',
    RIGHT_SHOE_SIZE: 'Storlek för höger fot',

    SEND_COPY: 'Skicka en kopia av detta e-postmeddelande till',
    SHARE: 'Dela',
    SHARE_DESIGN: 'Dela din design',
    SIZE_GUIDE: 'Storleksguide',
    SUBMIT: 'Skicka',
    UNDO: 'Ångra',
    VIEW_ALL: 'Se alla',
    WEVE_GOT_YOU: 'Vi hjälper dig! Om du lämnar den här sidan kommer dina MyJoys-val att sparas i dina designs för att fortsätta senare.',
    WOMENS: 'Dam',
    YOUR_NAME: 'Ditt namn',
    YOUR_EMAIL: 'Din e-post',
    INSTANCE_ERROR_HEADER: 'Ett fel uppstod när dina val skulle sparas.',
    INSTANCE_ERROR_BODY: 'Vi kan för nuvarande ej spara dina val. Försök igen om en liten stund.',
    UPDATE_CART: 'Uppdatera varukorg',
    PERSONALIZE_CHOOSE_OPTION: 'Välj ett alternativ',
    PERSONALIZE_SAME_LEFT: 'Samma på vänster sida',
    PERSONALIZE_SAME_RIGHT: 'Samma på höger sida',
    PERSONALIZE_NONE: 'Inget',
    PERSONALIZE_LOGO: 'Logga',
    PERSONALIZE_MONOGRAM: 'Monogram',
    MONOGRAM_COLOR: 'Monogramfärg',
};
